
export enum TextType {
  PARAGRAPHS = 'paragraphs',
  SENTENCES = 'sentences',
  WORDS = 'words',
  PAGE_LAYOUT = 'page layout'
}

export enum Theme {
  LATIN = 'Traditional Latin',
  CORPORATE = 'Corporate Jargon',
  CYBERPUNK = 'Cyberpunk/Sci-Fi',
  PIRATE = 'Pirate Speak',
  FOODIE = 'Gourmet Foodie',
  HIPSTER = 'Hipster Artisan',
  LEGAL = 'Legal Obfuscation',
  SAAS = 'SaaS Marketing'
}

export enum Framework {
  TAILWIND = 'Tailwind CSS',
  BOOTSTRAP = 'Bootstrap 5',
  MODERN_CSS = 'Modern CSS (BEM)',
  SEMANTIC = 'Semantic HTML (Raw)'
}

export interface Section {
  heading: string;
  content: string[];
  bullets?: string[];
  imagePrompt?: string;
  imageUrl?: string;
}

export interface PageStructure {
  title: string;
  heroSubtitle: string;
  sections: Section[];
}

export interface GeneratorConfig {
  type: TextType;
  count: number;
  theme: Theme;
  framework: Framework;
  startWithLorem: boolean;
  customWords: string;
  includeImages: boolean;
}
